import React from 'react';
import { LessonHomeworkSimpleView } from '../../../types/lesson_homeworks';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../../routes';
import './homeworkSubmissionBanner.module.scss';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';

const HomeworkSubmissionBannerForDesktop = observer(({ homework }: Props) => {
    return (
        <div styleName="homework-submission-banner" className="homework-submission-banner">
            <div styleName="text">準備ができたら提出しよう</div>
            <div>
                <Button
                    type="primary"
                    to={V3Routes.lessonHomeworkSubmission(homework.id)}
                    styleName="link-button"
                    className="homework-submission-link"
                >
                    提出する
                </Button>
                <Link
                    to={V3Routes.lessonHomeworkSubmissionsIndex(homework.id)}
                    styleName="homework-submissions-index-link"
                    className="homework-submissions-index-link"
                >
                    他の人の提出内容を見る
                </Link>
            </div>
        </div>
    );
});

const HomeworkSubmissionBannerForSp = observer(({ homework }: Props) => {
    return (
        <div styleName="homework-submission-banner">
            <div styleName="text">PCからのみ提出可能です</div>
            <Link to={V3Routes.lessonHomeworkSubmissionsIndex(homework.id)} styleName="homework-submissions-index-link">
                他の人の提出内容を見る
            </Link>
        </div>
    );
});

type Props = {
    homework: LessonHomeworkSimpleView;
};

export const HomeworkSubmissionBanner = observer(({ homework }: Props) => {
    const { isSp } = useViewportState();
    return (
        <>
            {isSp ? (
                <HomeworkSubmissionBannerForSp homework={homework} />
            ) : (
                <HomeworkSubmissionBannerForDesktop homework={homework} />
            )}
        </>
    );
});
